document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {



    AOS.init({
        delay: 250,
        once: true,
        disable: 'mobile'
    });


    $('body').on('click', '.contact-block-popup', function () {
        console.log("fire");
        $(this).parent().find(".pdm-lightbox--form").addClass('active');

    });


    /* ========================================================================================================================
   
      Sticky Scroll Section
   
   ======================================================================================================================== */
    var stickyScroll = (function () {

        var $sections = $('.sticky-section');
        if (!$sections.length) { return; }

        $sections.each(function () {
            var $currentSection = $(this);
            $(window).scroll(function () {
                var scrollPos = $(window).scrollTop();
                var nextSectionPos = $currentSection.next().offset().top;

                if (scrollPos < nextSectionPos) {
                    $currentSection.addClass("sticky-scroll");
                } else {
                    $currentSection.removeClass("sticky-scroll");
                }
            });
        });
    }());


    /* ========================================================================================================================
   
      Blog article sticky CTA
   
   ======================================================================================================================== */
    (function () {
        var card = document.querySelector('[data-blog-cta]');
        if (!card) { return; }

        var article = document.querySelector('.single-blog-post .post-content-wrapper');
        if (!article) { return; }

        var ratio = parseFloat(card.getAttribute('data-scroll-ratio'));
        if (!ratio || ratio <= 0) { ratio = 0.25; }

        var barActivated = false;
        var dismissed = false;
        var watchingScroll = false;
        var desktopQuery = window.matchMedia('(min-width: 1200px)');
        var related = document.querySelector('.related-posts--blog');

        function revealBar() {
            card.classList.add('is-visible');
            card.setAttribute('aria-hidden', 'false');
        }

        function concealBar() {
            card.classList.remove('is-visible');
            card.setAttribute('aria-hidden', 'true');
        }

        function relatedInView() {
            if (!related) { return false; }
            return related.getBoundingClientRect().top < window.innerHeight;
        }

        function pastTrigger() {
            var top = article.getBoundingClientRect().top + window.pageYOffset;
            var trigger = top + (article.offsetHeight * ratio);
            return window.pageYOffset + window.innerHeight >= trigger;
        }

        function syncBar() {
            if (desktopQuery.matches || dismissed) { return; }
            if (!barActivated && pastTrigger()) {
                barActivated = true;
            }
            if (barActivated && !relatedInView()) {
                revealBar();
            } else {
                concealBar();
            }
        }

        function watchScroll() {
            if (watchingScroll) { return; }
            watchingScroll = true;
            window.addEventListener('scroll', syncBar, { passive: true });
        }

        function unwatchScroll() {
            if (!watchingScroll) { return; }
            watchingScroll = false;
            window.removeEventListener('scroll', syncBar);
        }

        var closeButton = card.querySelector('[data-blog-cta-close]');
        if (closeButton) {
            closeButton.addEventListener('click', function (event) {
                event.preventDefault();
                dismissed = true;
                concealBar();
                unwatchScroll();
            });
        }

        function placeDesktopCard() {
            if (!desktopQuery.matches) {
                card.style.removeProperty('--blog-cta-stick');
                return;
            }
            var header = document.querySelector('.gheader');
            var adminBar = document.getElementById('wpadminbar');
            var offset = adminBar ? adminBar.offsetHeight : 0;
            offset += header ? header.offsetHeight : 80;
            card.style.setProperty('--blog-cta-stick', (offset + 16) + 'px');
        }

        function useDesktopCard() {
            unwatchScroll();
            card.classList.add('is-visible');
            card.setAttribute('aria-hidden', 'false');
            placeDesktopCard();
        }

        if (desktopQuery.matches) {
            useDesktopCard();
        } else {
            watchScroll();
            syncBar();
        }

        if (desktopQuery.addEventListener) {
            desktopQuery.addEventListener('change', function (event) {
                if (event.matches) {
                    useDesktopCard();
                } else {
                    card.style.removeProperty('--blog-cta-stick');
                    watchScroll();
                    syncBar();
                }
            });
        }

        window.addEventListener('resize', placeDesktopCard);
        window.addEventListener('load', placeDesktopCard);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(placeDesktopCard);
        }
    }());


    /* ========================================================================================================================
   
      Package Tabs
   
   ======================================================================================================================== */

    var elopementPackages = (function () {
        var $section = $('.elopement-packages');
        if (!$section.length) { return; }

        var $triggers = $section.find('.package-tabs .btn');
        var $content = $section.find('.package-content');

        $content.filter(function (i, el) {
            console.log("el.dataset.tab", el.dataset.tab);
            return el.dataset.tab.indexOf(3) === -1;
        }).addClass('hidden')

        // Add custom property to each content element to store its index
        $content.each(function (index) {
            $(this).css('--index', index);
        });;


        $triggers.click(function () {
            var ID = this.dataset.tab;
            $triggers.removeClass('active').filter(this).addClass('active');

            $content.addClass('hidden').filter(function (i, el) {
                var ids = el.dataset.tab.split(',');
                if (ids.indexOf(ID) >= 0) {
                    $(el).removeClass('hidden'); 
                }
            });
            if (typeof logAmplitudeEvent === 'function' && this.dataset.ampli) {
                try {
                    logAmplitudeEvent(this.dataset.ename, JSON.parse(this.dataset.ampli));
                } catch (err) { /* ignore bad tracking payload */ }
            }
        });
    }());

    // Must not throw — later click handlers (e.g. #loadmore AJAX) need to run preventDefault.
    $('.apli-track').click(function () {
        if (typeof logAmplitudeEvent !== 'function' || !this.dataset.ampli) {
            return;
        }
        try {
            var ampliData = JSON.parse(this.dataset.ampli);
            if (this.classList.contains('blog-cta__card')) {
                ampliData.cta_type = window.matchMedia('(min-width: 1200px)').matches ? 'sticky_card' : 'sticky_bar';
            }
            // Homepage hero CTA experiment: attach assigned variant (cache-safe)
            if (this.hasAttribute('data-hero-cta-exp') && window.SE_HERO_CTA_EXP_VERSION) {
                ampliData.exp_version = window.SE_HERO_CTA_EXP_VERSION;
                if (window.SE_HERO_CTA_EXP_NAME) {
                    ampliData.exp_name = window.SE_HERO_CTA_EXP_NAME;
                }
            }
            var cityCardsVersion = window.SE_CITY_CARDS_EXP_VERSION;
            var stampCityCardsExp = cityCardsVersion === 'A' || cityCardsVersion === 'B';
            if (stampCityCardsExp && (this.dataset.ename === 'Explore Venue - Clicked' || this.hasAttribute('data-city-cards-exp'))) {
                ampliData.exp_version = cityCardsVersion;
                if (window.SE_CITY_CARDS_EXP_NAME) {
                    ampliData.exp_name = window.SE_CITY_CARDS_EXP_NAME;
                }
            }
            logAmplitudeEvent(this.dataset.ename, ampliData);
        } catch (err) { /* ignore bad tracking payload */ }
    });


    /* ========================================================================================================================
   
       Stats Block
   
   ======================================================================================================================== */
    /*var statsBlock = (function () {  
    
       function addCommas(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
    
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
    
        return x1 + x2;
    }
    
    
       $statsSection = $('.stats-block');
        if (!$statsSection.length) { return };
    
        if ($(window).width() > 960) {
          $(window).on('scroll', function () {
            $('.stats-block .stat-item.aos-animate .count').not('.animate-started').each(function () {
    
                var $this = $(this);
                var number = $this.attr('data-count');
    
                $this.addClass('animate-started')
                $({
                    countNum: $this.text()
                }).animate({
                    countNum: number
                }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function () {
                        $this.text(addCommas(Math.floor(this.countNum)));
                    },
                    complete: function () {
                        this.countNum = addCommas(this.countNum);
                        $this.text(this.countNum);
                    }
                });
    
            });
        });   
    
      } else {
         $('.stats-block .stats-row__item .count').each(function () {
                var number = $(this).attr('data-count');
                $(this).text(number);
            });
        }
    
    }());*/

    /* ========================================================================================================================
   
     Sliders
   
   ======================================================================================================================== */

    /*var logosSlider = (function () {
    
        var $slider = $('.logos-slider');
        var $section = $('.logos-block');
    
        if (!$slider.length) { return; }
    
        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1.45,
                spaceBetween: 20,
                autoplay: {
               delay: 1000,
               disableOnInteraction: false,
             },
                 loop: true,
                breakpoints: {
    
                    960: {
                        slidesPerView: 2.75,
                    },
                    1200: {
                        slidesPerView: 4,
                    }
                }
            });
        });
    
       }());*/

    var destinationsSlider = (function () {

        var $slider = $('.destinations-slider');
        var $section = $('.destinations-block');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 20,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                },
                breakpoints: {

                    960: {
                        slidesPerView: 1.25,
                    },
                    1200: {
                        slidesPerView: 1.65,
                    }
                }
            });
        });

    }());


    var chooseTestimonials = (function () {

        var $slider = $('.choose-testimonials-slider');
        var $section = $('.choose-testimonials');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                scrollbar: {
                    el: $section.find('.swiper-scrollbar').get(0),
                    draggable: true,
                },
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                }
            });
        });

    }());


    var testimonialsImgs = (function () {

        var $slider = $('.testiomonials-img-slider');
        var $section = $('.testimonials-w-imgs');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                }
            });
        });

    }());


    var staff = (function () {

        var $slider = $('.staff-slider');
        var $section = $('.staff-block');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 20,
                scrollbar: {
                    el: $section.find('.swiper-scrollbar').get(0),
                    draggable: true,
                },
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                },
                breakpoints: {

                    960: {
                        slidesPerView: 3,
                        autoHeight: false
                    }

                }
            });
        });

    }());

    var contentSlider = (function () {

        var $slider = $('.content-slider');
        var $section = $('.content-slider-block');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 20,
                scrollbar: {
                    el: $section.find('.swiper-scrollbar').get(0),
                    draggable: true,
                },
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                },
                breakpoints: {

                    960: {
                        slidesPerView: 3,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false,
                        }

                    },
                    1200: {
                        slidesPerView: 4

                    }

                }
            });
        });

    }());

    var contentSliderpakage = (function () {

        var $slider = $('.content-pakage-slider');
        var $section = $('.content-pakage-slider-block');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 20,
                scrollbar: {
                    el: $section.find('.swiper-scrollbar').get(0),
                    draggable: true,
                },
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.1,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false,
                        }

                    },
                    550: {
                        slidesPerView: 2.2,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false,
                        }
                    },

                    900: {
                        slidesPerView: 3.2,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false,
                        }

                    },
                    1600: {
                        slidesPerView: 4.8

                    }

                }
            });
        });

    }());


    var coreValues = (function () {


        var $slider = $('.core-values-slider');
        var $section = $('.core-values');

        if (!$slider.length) { return; }
        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                spaceBetween: 16,
                init: false,

                scrollbar: {
                    el: $section.find('.swiper-scrollbar').get(0),
                    draggable: true,
                },
                navigation: {
                    nextEl: $section.find('.swiper-button-next').get(0),
                    prevEl: $section.find('.swiper-button-prev').get(0),
                },
            });

            if (window.innerWidth < 960) {
                swiper.init();
            }

        });
    }());


    var filterTabSliders = (function () {
        var $slider = $('.filterable-triggers-mobile');
        if (!$slider.length) { return; }
        $slider.each(function () {
            var $this = $(this);
            var slideCount = $this.find('.swiper-slide').length;
            var $controls = $this.find('.swiper-controls').length ? $this : $this.closest('.filterable-trigger-main');
            var swiper = new Swiper($this.get(0), {
                slidesPerView: slideCount > 1 ? 2 : 1,
                spaceBetween: 10,
                autoHeight: true, //enable auto height
                init: false,
                navigation: {
                    nextEl: $controls.find('.swiper-button-next').get(0),
                    prevEl: $controls.find('.swiper-button-prev').get(0),
                },
                breakpoints: {

                    600: {
                        slidesPerView: slideCount > 1 ? 2 : 1,
                    }

                }
            });

            if (window.innerWidth < 960) {
                swiper.init();
            }


        });
    }());


    var destinationsTabs = (function () {

        var $slider = $('.destinations-tab-slider');
        var $section = $('.destinations-tabs');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var $slider_card = $(this).find('.swiper-slide');

            if ($slider_card.length >= 4) {
                var swiper = new Swiper($this.get(0), {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                    autoHeight: true, //enable auto heigh
                    navigation: {
                        nextEl: $this.find('.swiper-button-next').get(),
                        prevEl: $this.find('.swiper-button-prev').get(),
                    },
                    breakpoints: {

                        960: {
                            slidesPerView: 3,
                            autoHeight: false
                        },

                        1600: {
                            slidesPerView: 4,
                            autoHeight: false, //enable auto heigh
                        }
                    }
                });

            }

        });

    }());

    var wildflowerDestinationsTabs = (function () {
        var $slider = $('.wildflower-destinations-tab-slider');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var $slider_card = $(this).find('.swiper-slide');

            if ($slider_card.length >= 4) {
                var swiper = new Swiper($this.get(0), {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                    autoHeight: true, //enable auto heigh
                    navigation: {
                        nextEl: $this.find('.swiper-button-next').get(),
                        prevEl: $this.find('.swiper-button-prev').get(),
                    },
                    breakpoints: {

                        960: {
                            slidesPerView: 3,
                            autoHeight: false
                        },

                        1600: {
                            slidesPerView: 4,
                            autoHeight: false, //enable auto heigh
                        }
                    }
                });

            }

        });

    }());

    var testimonialSlider = (function () {

        var $slider = $('.testimonials-slider');
        var $section = $('.testimonials-block');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1,
                autoHeight: true, //enable auto height
                navigation: {
                    nextEl: $this.find('.swiper-button-next').get(),
                    prevEl: $this.find('.swiper-button-prev').get(),
                },
            });

        });

    }());

    var mobileImageGallery = (function () {

        var $section = $('.image-gallery');
        var $slider = $('.gallery-mobile');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var swiper = new Swiper($this.get(0), {
                slidesPerView: 1.4,
                spaceBetween: 20,
                navigation: {
                    nextEl: $this.find('.swiper-button-next').get(),
                    prevEl: $this.find('.swiper-button-prev').get(),
                }
            });

        });

    }());

    var imageSlider = (function () {

        var $slider = $('.image-slider');
        var $section = $('.image-slider-block');

        if (!$slider.length) { return; }

        $slider.each(function () {
            var $this = $(this);
            var $slider_card = $(this).find('.swiper-slide');
            var sliderVersion = $this.data('version');


            if ($slider_card.length > 3) {
                var swiperConfig = {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    centeredSlides: true,
                    loop: true,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            autoHeight: false
                        },
                        1400: {
                            slidesPerView: sliderVersion === 'Yes' ? 3.5 : 2.5,
                        }
                    }
                };

                // Add navigation if arrows exist in DOM
                var $nextBtn = $this.find('.swiper-button-next');
                var $prevBtn = $this.find('.swiper-button-prev');
                
                if ($nextBtn.length && $prevBtn.length) {
                    swiperConfig.navigation = {
                        nextEl: $nextBtn.get(),
                        prevEl: $prevBtn.get(),
                    };
                }

                var swiper = new Swiper($this.get(0), swiperConfig);

            }

        });

    }());







    /* ========================================================================================================================
   
       Tabs 
   
   ======================================================================================================================== */
    var Tabs = (function () {
        // Iterate over each section with the class 'filterable'
        $('.filterable').each(function () {
            var $section = $(this);

            var $triggers = $section.find('.filterable__triggers .btn');
            var $content = $section.find('.filterable__content');

            var $firstContent = $(this).find(".filterable__triggers .btn").first().data("id");


            // First Frequent asked filtered
            $content.filter(function (i, el) {
                return el.dataset.id.indexOf($firstContent) === -1;
            }).addClass('hidden');

            $triggers.click(function () {
                var ID = this.dataset.id;

                // console.log(ID);

                $triggers.removeClass('active').filter(this).addClass('active');

                if (ID == 'all') {
                    $content.removeClass('hidden');
                } else {
                    $content.addClass('hidden').filter(function (i, el) {
                        var ids = el.dataset.id.split(',');

                        if (ids.indexOf(ID) >= 0) {
                            $(el).removeClass('hidden');
                        }
                    });
                }
            });
        });
    }());


    /* ========================================================================================================================
   
       Footer Menus
   
   ======================================================================================================================== */
    var footerMenus = (function () {
        var $navs = $('.gfooter-menus nav');
        if (!$navs.length) { return; }

        $navs.find('.h5').click(function (e) {
            var $this = $(this);
            var $navItem = $this.parent();
            var $content = $navItem.find('ul');
            var $otherNavs = $navItem.siblings('nav');

            if ($navItem.hasClass('active')) {
                $navItem.removeClass('active');
                $content.slideUp('fast');
            } else {
                $navItem.addClass('active');
                $otherNavs.removeClass('active').find('ul').slideUp('fast');
                $content.slideDown('fast');
            }
        })

    }());


    var LazyLoading = (function () {
        var instance = new LazyLoad();

        function lazyBGImages() {
            var $bgImages = $('[data-bg]:not(.lazy)');
            if ($bgImages.length) {
                $bgImages.each(function () {
                    $(this).addClass('lazy');
                });
            }
            instance.update();
        }

        function update() {
            lazyBGImages();
        }

        lazyBGImages();

        return {
            update: update
        }
    }());

    var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');

        $('a[href="#"]').click(
            function (e) { e.preventDefault(); return; }
        );

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('header').outerHeight();
            } else {
                scrollPos -= $('header').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos - 32
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        // window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            });
        }

        return { to: goTo }
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            var $accordion = $(this);
            var $content = $accordion.find('.accordion__content');

            if ($accordion.hasClass('active')) {
                $content.show();
            } else {
                $content.hide();
            }

            $accordion.find('.accordion__trigger').click(function (e) {
                e.preventDefault();
                var $this = $(this);
                var $accordion = $this.closest('.accordion');
                var $content = $accordion.find('.accordion__content');

                if ($accordion.hasClass('active')) {
                    $content.slideUp('fast', function () {
                        $accordion.removeClass('active');
                    });
                } else {
                    $content.slideDown('fast', function () {
                        $accordion.addClass('active');
                    });
                    $accordion.siblings().removeClass('active').find('.accordion__content').slideUp('fast');
                }
            });
        });
    }());


    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if (!$masks.length) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46];

            $('[data-mask]').keyup(function (e) {
                console.log(e.keyCode);
                if (exclude_keys.indexOf(e.keyCode) > -1) { return; }

                switch (this.dataset.mask) {
                    case 'digits':
                        var x = this.value.replace(/\D/g, '');
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        console.log(x);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.parent().hasClass('ginput_container') ? $el.parent().parent() : $el;
            }

            function setFilled($input) {
                $input.addClass('filled');
            }

            function removeFilled($input) {
                $input.removeClass('filled');
            }

            function setFocused() {
                $(this).addClass('focused');
            }

            function removeFocused() {
                $(this).removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'radio' ||
                    this.type == 'checkbox' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
        return { options: parselyOptions }
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?youtu(be\.com\/|\.be\/)(embed\/(.+)(\?.+)?|watch\?v=(.+)(\&.+)?)/g;
                var vimeoPattern = /(?:http?s?:\/\/)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/g;

                if (youtubePattern.test(iframe)) {
                    classes += ' youtube-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(youtubePattern, replacement);

                }

                if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$3?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                }

                $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).next('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeModal($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        function openModal($lightbox) {
            $lightbox.addClass('active');
            $('body').addClass('noScroll');
        }

        function updateModal($lightbox, $content) {
            $lightbox.find('.pdm-lightbox__content').html($content);
        }

        $('.pdm-lightbox').on('click', function (e) {
            if (e.target == this) {
                closeModal($(this));
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            closeModal($(this).closest('.pdm-lightbox'));
        });
        return {
            close: closeModal,
            open: openModal,
            update: updateModal
        };
    }());

    //******************************************************Everything under this is optional, feel free to delete

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $adminBar = $('#wpadminbar');





        var header_height = $header.innerHeight();
        if ($adminBar.length) { header_height += $adminBar.innerHeight(); }
        if (window.innerWidth < 960) { $nav.css({ marginTop: header_height }); }

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');

                var styles = { position: 'fixed' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight(); }

                $header.css(styles);
                $body.css({ marginTop: $header.innerHeight() });
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');

                var styles = { position: 'sticky' };
                if ($adminBar.length) { styles.top = $adminBar.innerHeight() };

                $header.css(styles);
                $body.css({ marginTop: 0 });
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });

            return {
                close: reset,
                open: activate
            }
        }());

        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.menu-item__dropdown');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.parent();

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);
        }());

        var StickyHeader = (function () {
            if (!$header.hasClass('sticky')) { return; }

            if (window.scrollY) {
                $header.addClass('sticky--scrolled');
            }

            $(window).on('scroll', function () {

                if (window.scrollY) {
                    $header.addClass('sticky--scrolled');

                } else if (window.scrollY === 0) {
                    $header.removeClass('sticky--scrolled');
                }

                if ($adminBar.length) {
                    $header.css({ top: $adminBar.innerHeight() });
                }

            });
        }());

        window.addEventListener('resize', function () {
            $header.css({ position: 'sticky' });
            BurgerMenu.close();

            var styles = { marginTop: window.innerWidth < 960 ? header_height : 0 };

            $nav.css(styles);
        });

    }());


    /* ========================================================================================================================
    
        SE AB Experiment Setup
    
    ======================================================================================================================== */


    /**
     * Decide A/B experiment version with sticky cookie
     *
     * @param {boolean} active        Experiment active or not
     * @param {number}  percentB      Percentage for version B (0–100)
     * @param {string}  cookieName    Cookie name
     * @param {string}  domain        Optional cookie domain (e.g. ".example.com")
     * @returns {string}              Assigned version: 'A' or 'B'
     */
    function setABVersion(active, percentB, cookieName, domain = null) {
        const YEAR_IN_SECONDS = 365 * 24 * 60 * 60;
        let version = 'A';

        const getCookie = (name) => {
            const match = document.cookie.match(
                new RegExp('(?:^|; )' + name.replace(/([$?*|{}\]\\\/+^])/g, '\\$1') + '=([^;]*)')
            );
            return match ? decodeURIComponent(match[1]) : null;
        };

        const setCookie = (name, value, options = {}) => {
            let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

            if (options.expires) {
                cookie += `; expires=${new Date(options.expires * 1000).toUTCString()}`;
            }
            if (options.path) cookie += `; path=${options.path}`;
            if (options.domain) cookie += `; domain=${options.domain}`;
            if (options.secure) cookie += `; secure`;
            if (options.samesite) cookie += `; samesite=${options.samesite}`;
    
            document.cookie = cookie;
        };

        const deleteCookie = (name, domain = null) => {
            setCookie(name, '', {
                expires: Math.floor(Date.now() / 1000) - 3600,
                path: '/',
                domain,
            });
        };

        // Experiment disabled → remove cookie
        if (!active) {
            deleteCookie(cookieName);
            if (domain) {
                deleteCookie(cookieName, domain);
            }
            return version;
        }

        // Sticky user
        const existing = getCookie(cookieName);
        if (percentB !== 100 && (existing === 'A' || existing === 'B')) {
            return existing;
        }

        // Normalize percentage
        percentB = Math.max(0, Math.min(100, parseInt(percentB, 10) || 0));

        // Random assignment (1–100)
        const rand = Math.floor(Math.random() * 100) + 1;
        version = rand <= percentB ? 'B' : 'A';

        const expires = Math.floor(Date.now() / 1000) + YEAR_IN_SECONDS;
        const secure = window.location.protocol === 'https:';

        // Save cookie (root)
        setCookie(cookieName, version, {
            expires,
            path: '/',
            secure,
            samesite: 'Lax',
        });

        // Save cookie (domain-wide, if provided)
        if (domain) {
            setCookie(cookieName, version, {
                expires,
                path: '/',
                domain,
                secure,
                samesite: 'Lax',
            });
        }

        return version;
    }

    // Expose ONE namespace only
    window.SE_AB = {
        setExperimentVersion: setABVersion
    };


    /* ========================================================================================================================
    
        Logged In
    
    ======================================================================================================================== */

    function getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            let [key, value] = cookie.trim().split('=');
            if (key === name) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }

    var updateLoginDiv = function() {
        console.log("Login div updated");
        const fav_exp_version = getCookie('_se_fav_experiment');
        if (fav_exp_version != 'B') {
            return;
        }
        const loginMobileDiv = $('.login-mobile-div');
        const loginDesktop = $('.login-desktop');
        const loginTextMobile = $('.login-mobile');
        const loggedIn = !!localStorage.getItem('_secb_entok');
        const userName = getCookie('user_name');
        
        //Declare primary state of elements if user is not logged in
        loginTextMobile.css({ display: 'block' });
        loginMobileDiv.html('');
        loginDesktop.html(`<a data-ename="Click_CTA" data-ampli="{&quot;page&quot;:&quot;California&quot;,&quot;section&quot;:&quot;Navigation&quot;,&quot;element&quot;:&quot;login&quot;}" href="${window.SITE_URL}/customer-dashboard/login" itemprop="url" class="menu-item__link apli-track"><span itemprop="name" class="menu-item__inner">Log In</span></a>`);
        
        if (!loggedIn || !userName) return;
        
        // Update div elements for logged in user
        loginTextMobile.css({ display: 'none' });
        const loginDesktopHtml = `<a href="${window.SITE_URL}/customer-dashboard/" class="header-login"><div class="initial">${userName.charAt(0).toUpperCase()}</div></a>`;
        loginDesktop.html(loginDesktopHtml);
        loginMobileDiv.html(loginDesktopHtml);
        
        // update margin top of navigation
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');
        var $adminBar = $('#wpadminbar');
        var headerHeight = $header.innerHeight();
        if ($adminBar.length) { headerHeight += $adminBar.innerHeight(); }
        if (window.innerWidth < 960) { $nav.css({ marginTop: headerHeight }); }
    };
    updateLoginDiv();

    // Listen for storage events (works across tabs)
    window.addEventListener('storage', function(e) {
        if (e.key === '_secb_entok') {
            updateLoginDiv();
        }
    });

    // Listen for custom event (works in same tab)
    window.addEventListener('authStateChanged', updateLoginDiv);


    /* ========================================================================================================================
    
        LoadMore
    
    ======================================================================================================================== */



    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        // Testimonials archive uses dedicated filter + load-more module.
        if ($('.testimonials-archive-filters').length) { return; }

        var $loadmore_text = $loadmore.text();
        var $postlist = $loadmore.siblings('.loadmore-container');
        var query = WP.query;
        var page = parseInt(WP.current_page) || 1; // Ensure that page is an integer
        var max = parseInt(WP.max_page) || 1;
        var post_type = $postlist.attr('data-type');
        var sortingOption = $(".sort-by__dropdown .btn.active").data('sort');

        // Sorting buttons click event
        $('.sort-by__dropdown .btn').on('click', function () {
            sortingOption = $(this).data('sort');
            console.log(sortingOption);
            resetLoadMore();
        });

        $loadmore.click(function (e) {
            e.preventDefault();
            if (page >= max) {
                $loadmore.addClass('hide');
                return;
            }
            var nextPage = page + 1;
            var nextPageUrl = $(this).attr('data-next-url') || $(this).attr('href') || '';
            var currentPageNum = nextPageUrl.match(/\/page\/(\d+)\//);
            var nextNextPageUrl = nextPageUrl;

            if (currentPageNum && currentPageNum[1]) {
                var nextNum = parseInt(currentPageNum[1], 10) + 1;
                nextNextPageUrl = nextPageUrl.replace(/\/page\/\d+\//, '/page/' + nextNum + '/');
            }

            var data = {
                action: 'load_more_posts',
                query: query,
                page: nextPage,
                order: sortingOption,
            };

            if (post_type) { data['post_type'] = post_type; }

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading More');
                },
                error: function (res) {
                    console.log(res);
                },
                success: function (posts) {
                    if (posts) {
                        $postlist.append(posts);
                        LazyLoading.update();
                        page = nextPage;
                        if (page >= max) {
                            $loadmore.addClass('hide');
                        }
                    } else {
                        $loadmore.addClass('hide');
                    }
                    $loadmore.attr('disabled', false).text($loadmore_text);
                    $loadmore.attr('data-next-url', nextNextPageUrl);
                }
            });
        });

        // Reset function to re-initialize the load more behavior
        function resetLoadMore() {
            page = 1;
            sortingOption = $(".sort-by__dropdown .btn.active").data('sort');
            console.log(sortingOption);
            $loadmore.removeClass('hide');
            LazyLoading.update();
        }

        // Public method to reset the load more behavior
        return {
            resetLoadMore: resetLoadMore
        };
    }());


    /* ========================================================================================================================
    
        Testimonials archive filters (AJAX)
    
    ======================================================================================================================== */

    var testimonialsArchive = (function () {
        var $section = $('.testimonials-archive');
        if (!$section.length || !$('.testimonials-archive-filters').length) { return; }

        var $filtersWrap = $('.testimonials-archive-filters');
        var venuesMap = {};

        try {
            venuesMap = JSON.parse($filtersWrap.attr('data-venues-map') || '{}');
        } catch (err) {
            venuesMap = {};
        }

        var $container = $section.find('.loadmore-container');
        var $loadmore = $section.find('#loadmore');
        var $loadmoreText = $loadmore.length ? $loadmore.text() : '';
        var $tags = $section.find('.testimonials-filter-tags');
        var $venueFilter = $section.find('.testimonials-filter[data-filter="venue"]');
        var state = {
            destination: [],
            venue: [],
            package: [],
            order: 'DESC',
            page: 1,
            maxPage: parseInt($section.data('max-page'), 10) || 1,
            query: typeof WP !== 'undefined' ? WP.posts : ''
        };

        function quoteLineHeight(el) {
            var lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
            return lineHeight || 26.35;
        }

        function clampTestimonialQuotes() {
            $container.find('.testimonial-card__quote-text').each(function () {
                var el = this;
                var clip = el.parentNode;
                var more = clip.parentNode.querySelector('.testimonial-card__more');
                if (!more) {
                    return;
                }

                if (el.classList.contains('is-expanded')) {
                    more.hidden = false;
                    return;
                }

                var clone = el.cloneNode(true);
                clone.className += ' is-measuring';
                clone.style.position = 'absolute';
                clone.style.visibility = 'hidden';
                clone.style.pointerEvents = 'none';
                clone.style.height = 'auto';
                clone.style.width = el.clientWidth + 'px';
                clip.appendChild(clone);

                var overflows = clone.scrollHeight > (quoteLineHeight(el) * 3) + 1;
                clip.removeChild(clone);
                more.hidden = !overflows;
                if (!overflows) {
                    more.setAttribute('aria-expanded', 'false');
                    more.textContent = more.getAttribute('data-label-more') || 'Read more';
                }
            });
        }

        function animateQuoteClip(clip, from, to, done) {
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduce) {
                done();
                return;
            }

            var finished = false;
            function finish(event) {
                if (finished || (event && (event.target !== clip || event.propertyName !== 'height'))) {
                    return;
                }
                finished = true;
                clip.removeEventListener('transitionend', finish);
                window.clearTimeout(timer);
                done();
            }

            clip.style.transition = 'none';
            clip.style.height = from + 'px';
            var lockedHeight = clip.offsetHeight;
            if (!lockedHeight) {
                clip.style.height = from + 'px';
            }
            clip.style.transition = '';
            clip.addEventListener('transitionend', finish);
            var timer = window.setTimeout(finish, 450);
            clip.style.height = to + 'px';
        }

        function toggleTestimonialQuote(button) {
            var clip = button.parentNode.querySelector('.testimonial-card__quote-clip');
            var text = clip && clip.querySelector('.testimonial-card__quote-text');
            if (!clip || !text || clip.getAttribute('data-animating') === '1') {
                return;
            }

            var expand = button.getAttribute('aria-expanded') !== 'true';
            var collapsedHeight = quoteLineHeight(text) * 3;
            var moreLabel = button.getAttribute('data-label-more') || 'Read more';
            var lessLabel = button.getAttribute('data-label-less') || 'Read less';

            clip.setAttribute('data-animating', '1');
            button.setAttribute('aria-expanded', expand ? 'true' : 'false');
            button.textContent = expand ? lessLabel : moreLabel;

            if (expand) {
                var start = clip.getBoundingClientRect().height;
                text.classList.add('is-expanded');
                animateQuoteClip(clip, start, text.scrollHeight, function () {
                    clip.style.height = 'auto';
                    clip.removeAttribute('data-animating');
                });
                return;
            }

            var fullHeight = clip.getBoundingClientRect().height;
            animateQuoteClip(clip, fullHeight, collapsedHeight, function () {
                text.classList.remove('is-expanded');
                clip.style.height = '';
                clip.removeAttribute('data-animating');
            });
        }

        function getSelected(filterKey) {
            var selected = [];
            $section.find('.testimonials-filter__checkbox[data-filter-key="' + filterKey + '"]:checked').each(function () {
                selected.push($(this).val());
            });
            return selected;
        }

        function getVenuesForDestinations(destinations) {
            var venues = [];

            if (!destinations.length) {
                return venues;
            }

            destinations.forEach(function (destination) {
                var list = venuesMap[destination] || [];
                list.forEach(function (venue) {
                    if (venues.indexOf(venue) === -1) {
                        venues.push(venue);
                    }
                });
            });

            venues.sort();
            return venues;
        }

        function setVenueFilterState(enabled) {
            var $toggle = $venueFilter.find('.testimonials-filter__toggle');

            if (enabled) {
                $venueFilter.removeClass('is-disabled');
                $toggle.prop('disabled', false);
                return;
            }

            $venueFilter.addClass('is-disabled');
            $toggle.prop('disabled', true).attr('aria-expanded', 'false');
            $venueFilter.find('.testimonials-filter__panel').attr('hidden', true);
            $toggle.find('.testimonials-filter__toggle-text').text(
                $toggle.find('.testimonials-filter__toggle-text').data('placeholder')
            );
        }

        function renderVenuePanel(venues, disabled) {
            var $panel = $venueFilter.find('.testimonials-filter__panel');
            var filterLabel = $venueFilter.find('.testimonials-filter__label').first().text();
            var selected = disabled ? [] : getSelected('venue').filter(function (value) {
                return venues.indexOf(value) !== -1;
            });

            $panel.empty();

            if (disabled) {
                $panel.append(
                    $('<p class="testimonials-filter__empty"></p>').text(
                        $venueFilter.data('empty-disabled') || 'Select a location first'
                    )
                );
                return;
            }

            if (!venues.length) {
                $panel.append(
                    $('<p class="testimonials-filter__empty"></p>').text(
                        $venueFilter.data('empty-enabled') || 'No venues available'
                    )
                );
                return;
            }

            venues.forEach(function (venue) {
                var $label = $('<label class="testimonials-filter__option"></label>');
                var $input = $('<input type="checkbox" class="testimonials-filter__checkbox" />');

                $input.attr({
                    name: 'venue[]',
                    value: venue,
                    'data-filter-key': 'venue',
                    'data-filter-label': filterLabel
                });

                if (selected.indexOf(venue) !== -1) {
                    $input.prop('checked', true);
                }

                $label.append($input).append($('<span></span>').text(venue));
                $panel.append($label);
            });
        }

        function onDestinationChange() {
            var destinations = getSelected('destination');

            if (!destinations.length) {
                setVenueFilterState(false);
                renderVenuePanel([], true);
                updateToggleLabels();
                renderTags();
                return;
            }

            setVenueFilterState(true);
            renderVenuePanel(getVenuesForDestinations(destinations), false);
            updateToggleLabels();
            renderTags();
        }

        function syncStateFromDom() {
            state.destination = getSelected('destination');
            state.venue = getSelected('venue');
            state.package = getSelected('package');
        }

        function updateToggleLabels() {
            $section.find('.testimonials-filter').each(function () {
                var $filter = $(this);
                var key = $filter.data('filter');
                var count = getSelected(key).length;
                var placeholder = $filter.find('.testimonials-filter__toggle-text').data('placeholder') ||
                    $filter.find('.testimonials-filter__toggle-text').text();

                if (!$filter.find('.testimonials-filter__toggle-text').data('placeholder')) {
                    $filter.find('.testimonials-filter__toggle-text').data('placeholder', placeholder);
                }

                if (count === 1) {
                    $filter.addClass('is-selected');
                    $filter.find('.testimonials-filter__toggle-text').text(getSelected(key)[0]);
                } else if (count > 1) {
                    $filter.addClass('is-selected');
                    $filter.find('.testimonials-filter__toggle-text').text(count + ' selected');
                } else {
                    $filter.removeClass('is-selected');
                    $filter.find('.testimonials-filter__toggle-text').text(placeholder);
                }
            });
        }

        function renderTags() {
            $tags.empty();
            $section.find('.testimonials-filter__checkbox:checked').each(function () {
                var $input = $(this);
                var key = $input.data('filter-key');
                var value = $input.val();
                var $tag = $('<button type="button" class="testimonials-filter-tag"></button>');
                $tag.text(value);
                $tag.attr('data-filter-key', key);
                $tag.attr('data-filter-value', value);
                $tag.append('<span class="testimonials-filter-tag__remove" aria-hidden="true">&times;</span>');
                $tags.append($tag);
            });
        }

        function updateLoadMoreVisibility() {
            if (!$loadmore.length) { return; }
            if (state.page >= state.maxPage) {
                $loadmore.addClass('hide');
            } else {
                $loadmore.removeClass('hide');
            }
        }

        function clearAllFilters() {
            $section.find('.testimonials-filter__checkbox').prop('checked', false);
            onDestinationChange();
            updateToggleLabels();
            renderTags();
            fetchPosts(1, 'replace');
        }

        function fetchPosts(paged, mode) {
            syncStateFromDom();
            state.page = paged;
            $section.addClass('loading');

            $.ajax({
                type: 'POST',
                url: ajaxURL,
                dataType: 'json',
                data: {
                    action: 'filter_testimonials',
                    paged: paged,
                    order: state.order,
                    destination: state.destination,
                    venue: state.venue,
                    package: state.package
                },
                success: function (res) {
                    if (!res || typeof res.html === 'undefined') {
                        return;
                    }

                    if (mode === 'append') {
                        $container.append(res.html);
                    } else {
                        $container.html(res.html);
                    }

                    state.maxPage = parseInt(res.max_page, 10) || 1;
                    state.query = res.query || state.query;

                    if (typeof WP !== 'undefined') {
                        WP.max_page = state.maxPage;
                        WP.current_page = state.page;
                        WP.posts = state.query;
                    }

                    updateLoadMoreVisibility();
                    renderTags();
                    updateToggleLabels();
                    clampTestimonialQuotes();

                    if (typeof LazyLoading !== 'undefined') {
                        LazyLoading.update();
                    } else if (typeof lazyLoadInstance !== 'undefined') {
                        lazyLoadInstance = new LazyLoad();
                    }

                    $section.removeClass('loading');
                },
                error: function () {
                    $section.removeClass('loading');
                }
            });
        }

        $section.on('click', '.testimonial-card__more', function (e) {
            e.preventDefault();
            toggleTestimonialQuote(this);
        });

        $section.on('click', '.testimonials-filter__toggle', function (e) {
            e.preventDefault();
            var $filter = $(this).closest('.testimonials-filter');

            if ($filter.hasClass('is-disabled') || $(this).prop('disabled')) {
                return;
            }

            var $panel = $filter.find('.testimonials-filter__panel');
            var isOpen = $panel.is(':visible');

            $section.find('.testimonials-filter__panel').attr('hidden', true);
            $section.find('.testimonials-filter__toggle').attr('aria-expanded', 'false');

            if (!isOpen) {
                $panel.removeAttr('hidden');
                $(this).attr('aria-expanded', 'true');
            }
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.testimonials-filter').length) {
                $section.find('.testimonials-filter__panel').attr('hidden', true);
                $section.find('.testimonials-filter__toggle').attr('aria-expanded', 'false');
            }
        });

        $section.on('change', '.testimonials-filter__checkbox', function () {
            if ($(this).data('filter-key') === 'destination') {
                onDestinationChange();
            }
            fetchPosts(1, 'replace');
        });

        $section.on('click', '.testimonials-filter-tag', function (e) {
            e.preventDefault();
            var key = $(this).data('filter-key');
            var value = $(this).data('filter-value');
            $section.find('.testimonials-filter__checkbox').filter(function () {
                return $(this).data('filter-key') === key && $(this).val() === value;
            }).prop('checked', false);

            if (key === 'destination') {
                onDestinationChange();
            }

            fetchPosts(1, 'replace');
        });

        $section.on('click', '.testimonials-filters-clear', function (e) {
            e.preventDefault();
            clearAllFilters();
        });

        $section.on('click', '.sort-by__dropdown .btn', function (e) {
            e.preventDefault();
            var $btn = $(this);
            $section.find('.sort-by__dropdown').removeClass('active');
            $section.find('.sort-by__dropdown .btn').removeClass('active');
            $btn.addClass('active');
            state.order = $btn.data('sort') || 'DESC';
            fetchPosts(1, 'replace');
        });

        $section.on('click', '.button-sort', function (e) {
            e.preventDefault();
            $(this).parent().find('.sort-by__dropdown').toggleClass('active');
        });

        if ($loadmore.length) {
            $loadmore.on('click', function (e) {
                e.preventDefault();
                if (state.page >= state.maxPage) {
                    $loadmore.addClass('hide');
                    return;
                }
                $loadmore.attr('disabled', true).text('Loading More');
                var nextPage = state.page + 1;

                $.ajax({
                    type: 'POST',
                    url: ajaxURL,
                    dataType: 'json',
                    data: {
                        action: 'filter_testimonials',
                        paged: nextPage,
                        order: state.order,
                        destination: state.destination,
                        venue: state.venue,
                        package: state.package
                    },
                    success: function (res) {
                        if (res && res.html) {
                            $container.append(res.html);
                            state.page = nextPage;
                            state.maxPage = parseInt(res.max_page, 10) || 1;
                            updateLoadMoreVisibility();
                            if (typeof LazyLoading !== 'undefined') {
                                LazyLoading.update();
                            }
                            clampTestimonialQuotes();
                        }
                        $loadmore.attr('disabled', false).text($loadmoreText);
                    },
                    error: function () {
                        $loadmore.attr('disabled', false).text($loadmoreText);
                    }
                });
            });
        }

        updateLoadMoreVisibility();
        clampTestimonialQuotes();

        var quoteResizeTimer;
        $(window).on('load resize', function () {
            window.clearTimeout(quoteResizeTimer);
            quoteResizeTimer = window.setTimeout(clampTestimonialQuotes, 150);
        });
    }());


    /* ========================================================================================================================
    
        Filtering Posts
    
    ======================================================================================================================== */

    var filteringPosts = (function () {

        if (!$('.filter-posts').length) { return; }

        $(".filter-posts .btn-filter").on('click', function () {
            var section = $(this).closest('section');
            var data = $(this).data()
            var slug = data.slug;
            var taxonomy = data.taxonomy;
            var post_type = data.type;

            $(section).find(".reset-filters").removeClass('active');
            $(section).find(".filter-posts .btn-filter").removeClass('active');
            $(this).addClass('active');

            //Hide sort
            $(section).find(".sort-by").addClass("hide");
            //Hide loadmore
            $(section).find("#loadmore").addClass("hide");
            // Loading animation
            $(section).addClass('loading');

            //Scroll
            $('html, body').animate({
                scrollTop: $(section).find('.loadmore-container').offset().top + $('header.gheader').height() - 350
            }, 1000);


            $.ajax({
                type: 'POST',
                url: ajaxURL,
                dataType: 'html',
                data: {
                    action: 'filter_posts',
                    post_type: post_type,
                    taxonomy: taxonomy,
                    slug: slug
                },
                success: function (res) {
                    $(section).find('.loadmore-container').html(res);
                    lazyLoadInstance = new LazyLoad();
                    $(section).removeClass('loading');
                }
            })



        });

        //Reset filters
        $('.reset-filters').on('click', function () {

            var section = $(this).closest('section');
            var data = $(this).data()
            var post_type = data.type;


            $(section).find(".filter-posts .btn-filter").removeClass('active');
            $(this).addClass('active');

            //Show sort
            $(section).find(".sort-by").removeClass("hide");

            //Show loadmore
            $(section).find("#loadmore").removeClass("hide");

            // Loading animation
            $(section).addClass('loading');


            //Scroll
            $('html, body').animate({
                scrollTop: $(section).find('.loadmore-container').offset().top + $('header.gheader').height() - 350
            }, 1000);

            // Use resetLoadMore function to reset the load more behavior
            LoadMore.resetLoadMore();

            // Perform AJAX request to reset filters
            $.ajax({
                type: 'POST',
                url: ajaxURL,
                dataType: 'html',
                data: {
                    action: 'filter_posts',
                    post_type: post_type,
                    reset: true
                },
                success: function (res) {
                    $(section).find('.loadmore-container').html(res);
                    lazyLoadInstance = new LazyLoad();
                    $(section).removeClass('loading');
                }
            });


        });

        //Sort By Dropdown
        $('.button-sort').on('click', function () {
            $(this).parent().find('.sort-by__dropdown').toggleClass("active");
        });

        //Sort by new or old
        $('.sort-by__dropdown .btn').on('click', function () {
            if ($(this).closest('.testimonials-archive').length) {
                return;
            }

            $(this).parent().removeClass("active");
            $('.sort-by__dropdown .btn').removeClass('active');
            $(this).addClass("active");
            var section = $(this).closest('section');
            var sortingOption = $(this).data('sort');
            var data = $(this).data()
            var post_type = data.type;
            var data = {
                action: 'sort_posts',
                post_type: post_type,
                sorting_option: sortingOption,
            };

            // Loading animation
            $(section).addClass('loading');

            // Use resetLoadMore function to reset the load more behavior
            LoadMore.resetLoadMore();


            $.ajax({
                type: 'POST',
                url: ajaxURL,
                dataType: 'html',
                data: data,
                success: function (res) {
                    $('.loadmore-container').html(res);
                    LazyLoading.update();
                    $(section).removeClass('loading');
                }
            });
        });
    }());


    /* ========================================================================================================================
        Hotels and Recommendations Page
    ======================================================================================================================== */
    // Get the scroller and items container elements
    const scroller = $('.scroll-container');
    const itemsContainer = $('.item-list');

    let isDragging = false;
    let startY, startScrollTop, startItemTop, draggedItem;

    // Add event listeners
    itemsContainer.on('mousedown', handleMouseDown);
    $(document).on('mousemove', handleMouseMove);
    $(document).on('mouseup', handleMouseUp);

    function handleMouseDown(e) {
        if ($(e.target).hasClass('item')) {
            isDragging = true;
            draggedItem = $(e.target);
            startY = e.clientY;
            startScrollTop = scroller.scrollTop();
            startItemTop = draggedItem.position().top;
        }
    }

    function handleMouseMove(e) {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const newTop = startItemTop + deltaY;

        // Calculate the max top position
        const maxTop = itemsContainer.height() - draggedItem.height();

        // Keep the item within the container bounds
        if (newTop >= 0 && newTop <= maxTop) {
            draggedItem.css('top', newTop + 'px');

            // Scroll the scroller if necessary
            const scrollAmount = deltaY / itemsContainer.height() * itemsContainer.prop('scrollHeight');
            scroller.scrollTop(startScrollTop - scrollAmount);
        }
    }

    function handleMouseUp() {
        isDragging = false;
    }

    // Re-adjust the scroller height when the window is resized
    $(window).on('resize', setScrollerHeight);

    // Set the height of the scroller based on the content
    function setScrollerHeight() {
        scroller.css('height', itemsContainer.height() + 'px');
    }

    // Initialize the scroller height
    setScrollerHeight();

    // Scroll items up when clicking the up arrow
    $('.places-navigation.up-arrow').on('click', function() {
        const itemHeight = itemsContainer.find('.item').first().outerHeight();
        scroller.animate({ scrollTop: '-=' + (itemHeight * 4) }, 500);
    });

    // Scroll items down when clicking the down arrow
    $('.places-navigation.down-arrow').on('click', function() {
        const itemHeight = itemsContainer.find('.item').first().outerHeight();
        scroller.animate({ scrollTop: '+=' + (itemHeight * 4) }, 500);
    });


    // bottom buttons scrolling S
    const csPlacesBottomBtnsScroll = () => {
        let scrollContainer = $('.places-bottom-scroll-container');

        if(scrollContainer.length > 0){
            // Set up drag and drop behavior for items
            let dragItem = null;
            let dragSpeedFactor = 2; // Adjust this value to control the drag speed

            $(document).on('mousedown', '.item', function(event) {
                dragItem = $(this);
                dragItem.css('cursor', 'grabbing');
            });

            $(document).on('mousemove', function(event) {
                if (dragItem !== null) {
                event.preventDefault();
                let scrollLeft = scrollContainer.scrollLeft();
                let movementX = -event.originalEvent.movementX * dragSpeedFactor; // Negate the movementX value
                scrollContainer.scrollLeft(scrollLeft - movementX);
                }
            });

            $(document).on('mouseup', function(event) {
                if (dragItem !== null) {
                dragItem.css('cursor', 'grab');
                dragItem = null;
                }
            });

            scrollContainer.on('mousewheel', function(event) {
                event.preventDefault();
                let scrollLeft = scrollContainer.scrollLeft();
                scrollContainer.scrollLeft(scrollLeft - event.originalEvent.wheelDelta); // Negate the wheelDelta value
            });
        }
    }    
    csPlacesBottomBtnsScroll();
    // bottom buttons scrolling E


    // Scroll and add class on sticky scroll section
    const sections = $(".places-item-box-col");
    const menuItems = $(".scroll-container ul li a, .places-bottom-scroll-container ul li a");

    // Function to remove active class from all menu items
    function removeAllActiveClasses() {
        menuItems.removeClass("active");
    }
    
    menuItems.on("click", function (e) {
        e.preventDefault();
        removeAllActiveClasses();
        $(this).addClass("active");
    });
});



document.addEventListener('DOMContentLoaded', function() {

    if (jQuery('#PastElopeContainer').length === 0) {
        return;
    }

    const siteConfig = {
        apiEndpoint: `${API_URLS.root_cs_api}/ever-after/search/`,
        apiToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzb3VyY2UiOiJ3ZWJzaXRlIn0.1rV1bNShoSznMqJ0w571YR5oaFK1_DbgicJ9PIodMLs'
    };

    const apiEndpoint = siteConfig.apiEndpoint;
    const apiToken = siteConfig.apiToken;

    // First, get the venue ID using AJAX
    jQuery.ajax({
        url: ajaxURL, // This should be defined in WordPress as 'admin-ajax.php'
        type: 'POST',
        data: {
            action: 'get_venue_id',
            vfid: place_page_venue_id // Create this action in your functions.php
        },
        success: function(response) {
            const venueId = response.venue_id;


            // console.log("payload.param_venue_id");
            //  console.log(response);
            
            // Then proceed with the API call
            // const requestOptions = {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'Authorization': 'Bearer ' + apiToken
            //     },
            //     body: JSON.stringify({
            //         'order': 'PO',
            //         'page': '1',
            //         'param_venue_id': venueId ?? (typeof place_page_venue_id !== 'undefined' ? place_page_venue_id : 0)
                    
            //     })
            // };
            

            const payload = {
                order: 'PO',
                page: '1'
            };

            if (venueId) {
                payload.param_venue_id = venueId;
                // console.log(payload.param_venue_id);
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + apiToken
                },
                body: JSON.stringify(payload)
            };

            // Continue with your existing fetch call...
            fetch(apiEndpoint, requestOptions)
                .then(response => response.json())
                .then(apiResponse => {
                    const apiData = apiResponse.result.listing;
                    const topRow = document.getElementById('gallery-top-row');

                    // Function to create gallery slide HTML
                    function createGallerySlide(item) {
                        return `
                            <div class="swiper-slide">
                                <div class="gallery-card">
                                    <img src="${item.thumb_img}" alt="${item.first_name}'s Wedding">
                                    <div class="card-overlay">
                                        <span>${item.market_name} • <em>${item.month}</em></span>
                                        <button class="btn btn--obsidian hero-button apli-track gallery-button" onclick="window.location.href='${window.SITE_URL}/simply-ever-after/detail/${item.id}'">See Gallery</button>
                                    </div>
                                </div>
                            </div>
                        `;
                    }

                    if (apiData.length > 0) {
                        jQuery('#PastElopeContainer').slideDown();
                    }

                    // Populate swiper slides
                    apiData.forEach((item) => {
                        const gallerySlide = createGallerySlide(item);
                        topRow.innerHTML += gallerySlide;
                    });

                    // Initialize Swiper
                    const swiper = new Swiper('.gallery-container', {
                        slidesPerView: 4,
                        spaceBetween: 20,
                        loop: true,
                        centeredSlides: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        // pagination: {
                        //     el: '.swiper-pagination',
                        //     clickable: true,
                        // },
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: true,
                        },
                        breakpoints: {
                            320: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                            1600: {
                                slidesPerView: 4,
                            },
                            2048: {
                                slidesPerView: 5,
                            },
                            2650: {
                                slidesPerView: 6,
                            },
                        }
                        
                    });                    

                    // Stop autoplay on mouse enter
                    swiper.el.addEventListener('mouseenter', () => {
                        swiper.autoplay.stop();
                    });

                    // Resume autoplay on mouse leave
                    swiper.el.addEventListener('mouseleave', () => {
                        swiper.autoplay.start();
                    });
                    
                })
                .catch(error => {
                    console.error('Error fetching gallery data:', error);
                    document.querySelector('.gallery-container').innerHTML = '<p>Unable to load gallery. Please try again later.</p>';
                });
        },
        error: function(xhr, status, error) {
            console.error('Error getting venue ID:', error);
            document.querySelector('.gallery-container').innerHTML = '<p>Unable to load gallery. Please try again later.</p>';
        }
    });
});






document.addEventListener("DOMContentLoaded", function() {
    var readMoreBtn = document.getElementById("readmore___button");
    var readLessBtn = document.getElementById("readless___button");
    var contentContainer = document.querySelector(".content__value-dis-text");
    if (!contentContainer) {
        return;
    }
    var paragraph = contentContainer.querySelector("p"); // Get the first <p> inside the container
    var fullText = paragraph.innerHTML;
    var words = fullText.split(" ");
    
    if (words.length > 20) {
        var previewText = words.slice(0, 46).join(" ") + "...";
        paragraph.innerHTML = previewText;
        readMoreBtn.style.display = "inline";
    } else {
        readMoreBtn.style.display = "none";
    }

    readMoreBtn.addEventListener("click", function(e) {
        e.preventDefault();
        paragraph.innerHTML = fullText;
        readMoreBtn.style.display = "none";
        readLessBtn.style.display = "inline";
    });

    readLessBtn.addEventListener("click", function(e) {
        e.preventDefault();
        paragraph.innerHTML = previewText;
        readMoreBtn.style.display = "inline";
        readLessBtn.style.display = "none";
    });
});





//read more function for icon box

document.addEventListener("DOMContentLoaded", function () {
  const boxes = document.querySelectorAll(".icon_box");
  const WORD_LIMIT = 20; // change as needed

  boxes.forEach((box) => {
    // Support either class or id (in case markup wasn’t changed)
    const readMoreBtn = box.querySelector(".readmore___button_icon_box, #readmore___button_icon_box");
    const readLessBtn = box.querySelector(".readless___button_icon_box, #readless___button_icon_box");
    const contentContainer = box.querySelector(".content__value-dis-text_icon_box");

    if (!contentContainer || (!readMoreBtn && !readLessBtn)) return;

    // Store full content once
    if (!contentContainer.dataset.fullContent) {
      contentContainer.dataset.fullContent = contentContainer.innerHTML;
    }

    // Make a plain-text preview from ALL inner HTML (handles multiple <p>, lists, etc.)
    const fullHTML = contentContainer.dataset.fullContent;
    const plainText = fullHTML
      .replace(/<[^>]+>/g, " ")   // strip tags
      .replace(/\s+/g, " ")       // collapse whitespace
      .trim();

    if (!plainText) {
      if (readMoreBtn) readMoreBtn.style.display = "none";
      if (readLessBtn) readLessBtn.style.display = "none";
      return;
    }

    const words = plainText.split(" ");
    if (words.length > WORD_LIMIT) {
      const preview = words.slice(0, WORD_LIMIT).join(" ") + "…";
      contentContainer.dataset.preview = preview;
      contentContainer.innerHTML = `<p>${preview}</p>`;
      if (readMoreBtn) readMoreBtn.style.display = "inline";
      if (readLessBtn) readLessBtn.style.display = "none";
    } else {
      if (readMoreBtn) readMoreBtn.style.display = "none";
      if (readLessBtn) readLessBtn.style.display = "none";
    }

    if (readMoreBtn) {
      readMoreBtn.addEventListener("click", function (e) {
        e.preventDefault();
        contentContainer.innerHTML = contentContainer.dataset.fullContent;
        if (readMoreBtn) readMoreBtn.style.display = "none";
        if (readLessBtn) readLessBtn.style.display = "inline";
      });
    }

    if (readLessBtn) {
      readLessBtn.addEventListener("click", function (e) {
        e.preventDefault();
        const preview = contentContainer.dataset.preview || "";
        contentContainer.innerHTML = `<p>${preview}</p>`;
        if (readMoreBtn) readMoreBtn.style.display = "inline";
        if (readLessBtn) readLessBtn.style.display = "none";
      });
    }
  });
});





//
const showQBLoader = (object, hide = false) => {
    const obj = jQuery(object);
    if (!window.reactStateAPI.quoteForm.quoteFormData() && obj.hasClass('btn-spinner')) {
        hide ? obj.removeClass('active') : obj.addClass('active');
        setTimeout(() => {
            if (!hide) obj.removeClass('active');
        }, 2500);
    }
}


//top banner js

function setPromoCookie() {
    // Set the expiration date to August 31, 2026
    const expirationDate = new Date(2026, 8, 31);
    // Set the cookie
    document.cookie = `exclusive_promo_2026=1; expires=${expirationDate.toUTCString()}; domain=.simplyeloped.com; path=/`;
    // Optional: Provide feedback to the user
    // console.log("Cookie 'exclusive_promo_2026' has been set.");
    if (ENVIRONMENT === 'production') {
        window.open('https://simplyeloped.com/venue-finder/', '_self');
    } else if (ENVIRONMENT === 'development') {
        window.open('https://alpha.simplyeloped.io/venue-finder/', '_blank');
    } else {
        window.open('http://localhost:3015/venue-finder/', '_blank');
    }
}



//content with slider

// document.addEventListener("DOMContentLoaded", function () {
//   var gallerySwiper = new Swiper(".gallerySwiper", {
//     slidesPerView: 1,
//     spaceBetween: 10,
//     loop: true,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//   });
// });


// ─── Social Share Widget ───────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
    var shareRoot = document.getElementById("share-root-widget");
    if (!shareRoot) return;

    var shareUrl     = shareRoot.dataset.url     || window.location.href;
    var shareMessage = shareRoot.dataset.message || document.title;
    var venueId      = shareRoot.dataset.venueId || "";
    var market       = shareRoot.dataset.market  || "";

    var triggerBtn  = shareRoot.querySelector(".share-icon-button");
    var panel       = shareRoot.querySelector(".share-panel");
    var copiedToast = shareRoot.querySelector(".share-copied-toast");
    if (!triggerBtn || !panel) return;

    var closeTimer  = null;
    var toastTimer  = null;
    var isPanelOpen = false;

    function formatUrl(url, params) {
        try {
            var u = new URL(url);
            Object.keys(params).forEach(function (k) { u.searchParams.set(k, params[k]); });
            return u.toString();
        } catch (e) {
            return url;
        }
    }

    function getVenueSlug() {
        var m = window.location.pathname.match(/\/venues\/([^/]+)/);
        return m ? m[1] : null;
    }

    function logShare(ename, props) {
        if (typeof logAmplitudeEvent === "function") {
            logAmplitudeEvent(ename, props);
        }
    }

    var isMobile = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);

    var builtUrl = formatUrl(shareUrl, { shared_by: "share_button", utm_medium: "share" });

    function openPanel() {
        logShare("venue_share_clicked", {
            domain_type: "main",
            page_type: "place_page",
            place_page_id: getVenueSlug() || venueId,
            destination_market: market,
        });

        if (isMobile && typeof navigator.share === "function") {
            doShare("");
            return;
        }

        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        triggerBtn.style.display = "none";
        panel.style.display      = "flex";
        panel.classList.remove("share-panel--closing");
        panel.classList.add("share-panel--opening");
        isPanelOpen = true;
    }

    function closePanel() {
        if (!isPanelOpen) return;
        isPanelOpen = false;
        panel.classList.remove("share-panel--opening");
        panel.classList.add("share-panel--closing");
        closeTimer = setTimeout(function () {
            panel.style.display = "none";
            panel.classList.remove("share-panel--closing");
            triggerBtn.style.display = "";
        }, 300);
    }

    function doShare(type) {
        var shareType = (isMobile && typeof navigator.share === "function") ? "native_share" : type;
        var shareInfo = { share_type: shareType };
        if (venueId) shareInfo.venue_id = venueId;

        var shareHref = "";
        if (type === "mail")      shareHref = "https://mail.google.com/mail/?view=cm&fs=1&to=&su=" + shareMessage + "&body=" + encodeURIComponent(shareMessage + "\r\n" + builtUrl);
        if (type === "facebook")  shareHref = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(builtUrl) + "&src=sdkpreparse";
        if (type === "whatsapp")  shareHref = "https://api.whatsapp.com/send?text=" + encodeURIComponent(shareMessage + " " + builtUrl);

        if (type === "link") {
            navigator.clipboard.writeText(builtUrl).then(function () {
                if (copiedToast) {
                    copiedToast.style.display = "block";
                    if (toastTimer) clearTimeout(toastTimer);
                    toastTimer = setTimeout(function () {
                        copiedToast.style.display = "none";
                    }, 3000);
                }
            });
            return;
        }

        logShare("venue_shared", shareInfo);

        if (isMobile && typeof navigator.share === "function") {
            navigator.share({ text: shareMessage, url: builtUrl });
        } else {
            window.open(shareHref, "sharer", "toolbar=0,status=0,width=648,height=395");
        }
    }

    triggerBtn.addEventListener("click", openPanel);

    panel.addEventListener("click", function (e) {
        var el = e.target.closest("[data-action]");
        if (!el) return;
        var action = el.dataset.action;
        if (action === "close") {
            closePanel();
        } else {
            doShare(action);
        }
    });

    document.addEventListener("click", function (e) {
        if (isPanelOpen && !shareRoot.contains(e.target)) {
            closePanel();
        }
    });
});

// Add this after your existing gallerySwiper code
document.addEventListener("DOMContentLoaded", function () {
  var galleryEl = document.querySelector(".gallerySwiper");
  var popupEl = document.querySelector(".galleryPopupSwiper");
  var popup = document.getElementById("galleryPopup");
  var galleryButtons = document.querySelectorAll(".view-gallery-btn");

  if (!galleryEl || !popupEl || !popup || !galleryButtons.length || typeof Swiper === "undefined") {
    return;
  }

  // Your existing gallerySwiper
  var gallerySwiper = new Swiper(galleryEl, {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Popup swiper
  var popupSwiper = new Swiper(popupEl, {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".popup-next",
      prevEl: ".popup-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // Open popup when clicking "View Full Gallery"
  galleryButtons.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      
      // Get current slide index from main gallery
      var currentIndex = gallerySwiper.realIndex;
      
      // Open popup
      popup.style.display = "block";
      setTimeout(function() {
        popup.style.opacity = "1";
      }, 10);
      
      // Navigate popup to the same slide
      popupSwiper.slideToLoop(currentIndex, 0);
    });
  });

  // Close popup
  function closePopup() {
    popup.style.opacity = "0";
    setTimeout(function() {
      popup.style.display = "none";
    }, 300);
  }

  var closeButton = popup.querySelector(".gallery-popup-close");
  var overlay = popup.querySelector(".gallery-popup-overlay");
  if (closeButton) closeButton.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);
  
  // Close on Escape key
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && popup.style.display === "block") {
      closePopup();
    }
  });
});